import Avatar from './avatar'
import AvatarGroup from './avatarGroup'

Avatar.Group = AvatarGroup

export default Avatar